import React from 'react';
import { Badge } from '@cvent/carina/components/Badge';
import { useTranslate } from 'nucleus-text';

import { injectTestId } from '@cvent/nucleus-test-automation';

interface NotificationBadgeProps {
  unreadNotificationsCount: number;
  isNotificationsLoading: boolean;
}

function NotificationBadge({ unreadNotificationsCount, isNotificationsLoading }: NotificationBadgeProps): JSX.Element {
  const { translate } = useTranslate();
  if (!unreadNotificationsCount || isNotificationsLoading) return null;

  const count =
    unreadNotificationsCount > 99 ? translate('Notifications-UnreadCount-99') : `${unreadNotificationsCount}`;
  return <Badge content={count} variant="danger" {...injectTestId('unread-notifications-count-badge')} />;
}

export default React.memo(NotificationBadge);
